export default __webpack_public_path__ + "static/media/back-arrow_light.9452c4b6.svg";